import { render, staticRenderFns } from "./EditarSindicato.vue?vue&type=template&id=76af4f62&"
import script from "./EditarSindicato.vue?vue&type=script&lang=js&"
export * from "./EditarSindicato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports